import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from '../data/contact';

function PrivacyPage() {
  return (
    <div className="container" style={{ maxWidth: '900px', margin: '0 auto' }}>
      <div className="card">
        <div className="card-header">Privacy Policy</div>
        <div className="legal-content" style={{ padding: '1rem', lineHeight: 1.65 }}>
          <p style={{ color: '#6b7280', marginTop: 0 }}>
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <h3>1. Overview</h3>
          <p>
            This Privacy Policy explains how GetSkimp (“we,” “us,” or “our”) collects, uses, shares, and
            protects information about you when you use our website, web application, and related
            services (collectively, the “Services”). We are committed to handling your information
            responsibly and transparently.
          </p>

          <h3>2. Information We Collect</h3>
          <p>We collect information in three main ways: directly from you, automatically, and from third parties.</p>

          <h4>2.1 Information You Provide Directly</h4>
          <p>This includes:</p>
          <ul>
            <li>
              <strong>Account and contact information</strong> such as your name, email address, phone number,
              and password when you create an account or communicate with us.
            </li>
            <li>
              <strong>Insurance request information</strong> such as property address, occupancy details, prior
              insurance history, and other risk-related information that may be required to obtain quotes.
            </li>
            <li>
              <strong>Communications and support requests</strong> including messages you send through forms,
              email, or in‑product messaging tools.
            </li>
          </ul>

          <h4>2.2 Information Collected Automatically</h4>
          <p>
            When you use the Services, we may automatically collect certain technical information, including:
          </p>
          <ul>
            <li>Device and browser information (such as type, version, and settings).</li>
            <li>Log data (such as pages visited, timestamps, referring URLs, and error data).</li>
            <li>Approximate location information derived from your IP address.</li>
            <li>
              Cookies and similar technologies that help us remember your preferences, understand how you use
              the Services, and improve performance.
            </li>
          </ul>

          <h4>2.3 Information from Third Parties</h4>
          <p>
            We may receive information about you from insurance carriers, producers, data enrichment providers,
            or other partners that help us validate or supplement the information you provide (for example,
            verifying an address or estimating property characteristics).
          </p>

          <h3>3. How We Use Your Information</h3>
          <p>We use the information we collect for purposes including:</p>
          <ul>
            <li>Operating, maintaining, and improving the Services.</li>
            <li>Creating and managing your account and authenticating your access.</li>
            <li>
              Processing your insurance‑related requests and sharing relevant details with carriers and licensed
              producers so they can evaluate eligibility, provide quotes, and service policies.
            </li>
            <li>Communicating with you about your account, requests, and product updates.</li>
            <li>Personalizing your experience, such as pre‑filling forms or tailoring content.</li>
            <li>Detecting, preventing, and responding to fraud, abuse, security incidents, and legal requests.</li>
            <li>Complying with applicable laws, regulations, and industry standards.</li>
          </ul>

          <h3>4. How We Share Information</h3>
          <p>We may share your information in the following circumstances:</p>
          <ul>
            <li>
              <strong>With insurance providers and producers</strong> so they can underwrite, quote, bind, and
              service insurance products you request.
            </li>
            <li>
              <strong>With service providers</strong> that perform services on our behalf, such as hosting,
              analytics, customer support, email delivery, and security.
            </li>
            <li>
              <strong>For legal and safety reasons</strong> when we believe disclosure is necessary to comply with
              the law, protect our rights, or prevent harm to you or others.
            </li>
            <li>
              <strong>In connection with a business transaction</strong> such as a merger, acquisition, financing,
              or sale of assets, where your information may be transferred as part of that transaction.
            </li>
          </ul>
          <p>We do not sell your personal information for money.</p>

          <h3>5. Cookies and Tracking Technologies</h3>
          <p>
            We and our service providers may use cookies, web beacons, and similar technologies to operate the
            Services, remember your settings, understand usage patterns, and improve performance. You can adjust
            your browser settings to refuse cookies or alert you when cookies are being sent, but some features of
            the Services may not function properly without them.
          </p>

          <h3>6. Data Retention</h3>
          <p>
            We retain your information for as long as reasonably necessary to provide the Services, comply with
            our legal obligations, resolve disputes, and enforce our agreements. The specific retention period
            may vary depending on the type of information and the context in which it was collected.
          </p>

          <h3>7. Your Choices and Rights</h3>
          <p>
            Depending on your location, you may have certain rights in relation to your personal information,
            such as the right to access, correct, or delete it, or to object to or restrict certain processing.
            You can also:
          </p>
          <ul>
            <li>Update certain account information directly in the app.</li>
            <li>Opt out of non‑essential marketing emails by using the unsubscribe link in those messages.</li>
            <li>
              Contact us to request access to, or deletion of, specific information, subject to legal and
              contractual limitations.
            </li>
          </ul>

          <h3>8. Security</h3>
          <p>
            We use administrative, technical, and physical safeguards designed to protect your information. No
            system can be guaranteed to be completely secure, and we cannot promise or guarantee that unauthorized
            access, hacking, data loss, or other breaches will never occur. We encourage you to use a strong,
            unique password and to keep your account credentials confidential.
          </p>

          <h3>9. Children&apos;s Privacy</h3>
          <p>
            The Services are not directed to children under 18, and we do not knowingly collect personal
            information from children under 18. If we learn that we have collected such information, we will take
            reasonable steps to delete it.
          </p>

          <h3>10. International Users</h3>
          <p>
            The Services are intended for users located in the United States. If you access the Services from
            outside the United States, you understand that your information may be processed and stored in the
            United States, where data protection laws may be different from those in your jurisdiction.
          </p>

          <h3>11. Changes to This Policy</h3>
          <p>
            We may update this Privacy Policy from time to time. When we make material changes, we will post the
            updated policy in the application and update the “Last updated” date above. Your continued use of the
            Services after an update becomes effective means you accept the revised policy.
          </p>

          <h3>12. Contact Us</h3>
          <p>
            If you have questions or concerns about this Privacy Policy or our privacy practices, you can contact
            us at&nbsp;
            <a href="mailto:privacy@getskimp.com">privacy@getskimp.com</a>
            &nbsp;or call&nbsp;
            <a href={SUPPORT_PHONE_TEL}>{SUPPORT_PHONE_DISPLAY}</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;


